import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FingerprintIcon, ActivityIcon, ShieldCheckIcon } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-24 px-4 bg-[#0a0e1a] relative overflow-hidden" data-id="element-196">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#c9a84c]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-197" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-198">
        <FadeIn data-id="element-199">
          <div className="text-center mb-16" data-id="element-200">
            <h2 className="text-3xl md:text-5xl font-bold text-[#f5f5f5] mb-6" data-id="element-201">
              Después de analizar a cientos de hombres exitosos de 40, 50 y 60
              años,{' '}
              <span className="text-[#c9a84c]" data-id="element-202">descubrimos un patrón.</span>
            </h2>
            <p className="text-xl text-[#9ca3af] max-w-3xl mx-auto" data-id="element-203">
              No eran los suplementos de $200 USD ni las cirugías. Era un{' '}
              <strong className="text-white" data-id="element-204">"Interruptor Hormonal"</strong> que
              puedes activar mediante micro-hábitos de biohacking.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-205">
          <FadeIn delay={0.1} data-id="element-206">
            <div className="bg-[#111827] border border-[#c9a84c]/20 p-8 rounded-2xl h-full flex flex-col items-center text-center" data-id="element-207">
              <div className="w-16 h-16 bg-[#c9a84c]/10 rounded-full flex items-center justify-center mb-6 text-[#c9a84c]" data-id="element-208">
                <FingerprintIcon className="w-8 h-8" data-id="element-209" />
              </div>
              <h3 className="text-xl font-bold text-[#f5f5f5] mb-4" data-id="element-210">
                No es falta de voluntad
              </h3>
              <p className="text-[#9ca3af]" data-id="element-211">
                El problema es que intentas usar métodos diseñados para chicos
                de 20 años. Tu cuerpo necesita una estrategia diferente.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-212">
            <div className="bg-[#111827] border border-[#c9a84c]/20 p-8 rounded-2xl h-full flex flex-col items-center text-center relative overflow-hidden" data-id="element-213">
              <div className="absolute inset-0 bg-gradient-to-b from-[#c9a84c]/5 to-transparent pointer-events-none" data-id="element-214" />
              <div className="w-16 h-16 bg-[#c9a84c]/10 rounded-full flex items-center justify-center mb-6 text-[#c9a84c]" data-id="element-215">
                <ActivityIcon className="w-8 h-8" data-id="element-216" />
              </div>
              <h3 className="text-xl font-bold text-[#f5f5f5] mb-4" data-id="element-217">
                Reduce el Cortisol
              </h3>
              <p className="text-[#9ca3af]" data-id="element-218">
                Una estrategia que reduzca el cortisol de inmediato para
                permitir que tu testosterona vuelva a fluir de forma natural.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-219">
            <div className="bg-[#111827] border border-[#c9a84c]/20 p-8 rounded-2xl h-full flex flex-col items-center text-center" data-id="element-220">
              <div className="w-16 h-16 bg-[#c9a84c]/10 rounded-full flex items-center justify-center mb-6 text-[#c9a84c]" data-id="element-221">
                <ShieldCheckIcon className="w-8 h-8" data-id="element-222" />
              </div>
              <h3 className="text-xl font-bold text-[#f5f5f5] mb-4" data-id="element-223">
                Código Alfa 40+
              </h3>
              <p className="text-[#9ca3af]" data-id="element-224">
                Eso es exactamente lo que hace este protocolo. Diseñado para el
                metabolismo y estilo de vida del hombre latino maduro.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}